export default "__VITE_ASSET__DAdIkTIb__"